import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-unused-vars
export default function Menu(_: Theme) {
  return {
    MuiMenuItem: {},
  };
}
